
<template>
    <transition name="modal-fade">
        <div class="modal" tabindex="-1" role="dialog">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{ $t('datasetDelete') }}</h5>
                    <button type="button" class="btn-close" data-dismiss="modal" @click="close" aria-label="Close" />
                </div>
                <div class="modal-body">
                    <p v-if="canDeleteDataset" style="margin-bottom:0">{{ $t('wannaDeleteThisDataset') }}</p>
                    <p v-else>{{ $t('cannotDeleteDataset') }} </p>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" @click="close" data-dismiss="modal" >
                        {{ $t('close') }}
                    </button>
                    <button type="button" class="btn btn-primary" @click="deleteDataset" :disabled="!canDeleteDataset" >
                        {{ $t('delete') }}
                    </button>
                </div>
                </div>
            </div>
        </div>      
    </transition>
</template>

<script>
import AssetTypeApi from '../../api/server/assetType';
import DatasetApi from "../../api/server/dataset";

export default {
    name: "datasetDeleteModal",
    props: {
        datasetId: {
            type: Number,
            required: true
        },
        modelingId: {
            type: Number,
            required: true
        }
    },
    mounted() {
            console.log(this.$parent)
        this.requestData();
    },
    methods: {
        async requestData() {
            var assetTypes = await AssetTypeApi.assetTypeList(this.modelingId);
            console.log(assetTypes.filter(a => a.datasetId == this.datasetId).length == 0)
            this.canDeleteDataset = assetTypes.filter(a => a.datasetId == this.datasetId).length == 0;
        },
        close() {
            this.$emit("closeDeleteDialog");
        },
        async deleteDataset() {
            await DatasetApi.datasetDelete(this.modelingId, this.datasetId);
            this.$emit("closeDeleteDialog");
            this.$emit("reload");
        },
    },
    data() {
        return {
            canDeleteDataset: false
        }
    }
};
</script>